import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=9854a24a"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports